import { useEffect, useState } from "react";

const Grade = (props) => {
    const { name, defaultValue, theme = "primary", size = 5 } = props;
    const [value, setValue] = useState(0);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const activeClass = `btn-${theme}`;
    const inactiveClass = `btn-outline-${theme}`;

    const onClickGrade = (e, grade) => {
        e.preventDefault();
        setValue(grade);
        setTimeout(() => {
            props.onChange && props.onChange(e, { key: name, value: grade });
        });
    }

    return (
        <>
            <input type="hidden" name={name} value={value} readOnly={true} />
            <div className={"btn-group"} style={{ width: "100%" }}>
                <button className={`btn btn-sm ${(value === 0 ? activeClass : inactiveClass)}`} onClick={(e) => onClickGrade(e, 0)}>-</button>
                <button className={`btn btn-sm ${(value === 1 ? activeClass : inactiveClass)}`} onClick={(e) => onClickGrade(e, 1)}>1</button>
                <button className={`btn btn-sm ${(value === 2 ? activeClass : inactiveClass)}`} onClick={(e) => onClickGrade(e, 2)}>2</button>
                <button className={`btn btn-sm ${(value === 3 ? activeClass : inactiveClass)}`} onClick={(e) => onClickGrade(e, 3)}>3</button>
                {size >= 4 && (<button className={`btn btn-sm ${(value === 4 ? activeClass : inactiveClass)}`} onClick={(e) => onClickGrade(e, 4)}>4</button>)}
                {size >= 5 && (<button className={`btn btn-sm ${(value === 5 ? activeClass : inactiveClass)}`} onClick={(e) => onClickGrade(e, 5)}>5</button>)}
            </div>
        </>
    );
};

const OnOff = (props) => {
    const { name, defaultChecked, theme = "primary" } = props;
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(defaultChecked === true);
    }, [defaultChecked]);

    const activeClass = `btn-${theme}`;
    const inactiveClass = `btn-outline-${theme}`;

    const onClickChecked = (e, bool) => {
        e.preventDefault();
        setChecked(bool);
        setTimeout(() => {
            props.onChange && props.onChange(e, { key: name, value: bool });
        });
    };

    return (
        <div>
            <input type="hidden" name={name} value={checked} readOnly={true} />
            <div className={"btn-group"} style={{ width: "100%" }}>
                <button className={`btn btn-sm ${(checked !== true ? activeClass : inactiveClass)}`} onClick={(e) => onClickChecked(e, false)}>OFF</button>
                <button className={`btn btn-sm ${(checked === true ? activeClass : inactiveClass)}`} onClick={(e) => onClickChecked(e, true)}>ON&nbsp;</button>
            </div>
        </div>
    );
};

export { Grade, OnOff };
